module.exports = __webpack_public_path__ + "static/approach-e26549215e516ef05f2e9c333f6fe90c.jpg";